<template>
    <div class="box">
       <el-divider>Student's Photo</el-divider>
       <el-row :gutter="10" type="flex">
          <el-col :span="4">
             File uploaded 1
          </el-col>
          <el-col>
            <upload v-if="studentPhoto" :disabled="true" :imageurl="studentPhoto.path"></upload>
          </el-col>
       </el-row>
       <el-divider>Student’s Birth Certificate and HKID Card / Passport</el-divider>
       <el-row :gutter="10" type="flex" v-for="(item,index) in birthCertificate" :key="index + 'birthCertificate'">
          <el-col :span="4">
             File uploaded {{index +1}}
          </el-col>
          <el-col>
               <upload v-if="birthCertificate" :disabled="true"  :imageurl="item.path"></upload>
          </el-col>
       </el-row>
       <template v-if="type !== 0">
       <el-divider> Academic Reports of the Recent Three Years</el-divider>
       <el-row :gutter="20" type="flex" v-for="(item,index) in scoreSheet" :key="index">
          <el-col :span="4">
             File uploaded {{index +1}}
          </el-col>
          <el-col>
               <upload v-if="scoreSheet" :disabled="true"  :imageurl="item.path"></upload>
          </el-col>
       </el-row>
       </template>
       <template v-if="type !== 0">
       <el-divider> Award Certificates of the Recent Three Years (選填 Optional)</el-divider>
        <el-row :gutter="20" type="flex" v-for="(item,index) in certificateAward" :key="index+'certificateAward'">
          <el-col :span="4">
             File uploaded {{index +1}}
          </el-col>
          <el-col>
               <upload v-if="certificateAward" :disabled="true"  :imageurl="item.path"></upload>
          </el-col>
       </el-row>
       </template>
       <template v-if="type !== 0">
       <el-divider> Non-academic Reports of the Recent Three Years  (選填 Optional)</el-divider>
       <el-row :gutter="20" type="flex" v-for="(item,index) in achievement" :key="index+'achievement'">
          <el-col :span="4">
             File uploaded {{index +1}}
          </el-col>
          <el-col>
               <upload v-if="achievement" :disabled="true"  :imageurl="item.path"></upload>
          </el-col>
       </el-row>
       </template>
       <template v-if="type !== 0">
       <el-divider> Recommendation Letter from the Principal of the Present/Last School  (選填 Optional)</el-divider>
       <el-row :gutter="20" type="flex" v-for="(item,index) in letterRecommendation" :key="index+'letterRecommendation'">
          <el-col :span="4">
             File uploaded {{index +1}}
          </el-col>
          <el-col>
               <upload v-if="letterRecommendation" :disabled="true"  :imageurl="item.path"></upload>
          </el-col>
       </el-row>
       </template>
       <template v-if="type==2 && type !== 0">
       <el-divider>Photocopy of P.6 Student Identification Form (issued by EDB)</el-divider>
       <el-row :gutter="20" type="flex">
          <el-col :span="4">
             File uploaded 1
          </el-col>
          <el-col>
               <upload v-if="photocopy" :disabled="true" :imageurl="photocopy.path"></upload>
          </el-col>
       </el-row>
       </template>
    </div>
</template>

<script>
    import upload from '@/components/upload'
    export default {
        components:{upload},
        props:{
            formLabelAlign:{
                type:Object,
                default:function(){}
            },
            type: {
                type: Number,
                default: 0,
            },
        },
        watch:{
            formLabelAlign:{
                handler(v){
                    if(v!==null){
                      let componentForm =  v.components.filter((v)=>{
                             return v.type == 3
                        })[0]
                       this.studentFiles = JSON.parse(componentForm.value) 
                    }
                }
            }
        },
        data() {
            return {
                studentFiles: []
            }
        },
        computed:{
            studentPhoto(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 0
                })[0]
            },
            birthCertificate(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 1
                })
            },
            scoreSheet(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 2
                })
            },
            certificateAward(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 3
                })
            },
            achievement(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 4
                })
            },
            letterRecommendation(){
                return this.studentFiles.filter((v)=>{
                    return v.type == 5
                })
            },
            photocopy(){
            return this.studentFiles.filter((v)=>{
                return v.type == 6
            })[0]
        },
        },
    }
</script>

<style lang="scss" scoped>
.box{
    padding: 30px 0;
}
</style>